export default "/build/images/discover.3dde2fd5.png";